// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForStreamingProjectsSPPage } from '@streaming-projects/links';
import { useDeleteClusterLinkingWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPClusterLinkingWorkloadDeleteWarningModal = ({
  isOpen,
  onClose,
  clusterLinkingWorkloadName,
  clusterLinkingWorkloadId,
  clusterLinkingWorkloadResourceId,
  spVersion,
}) => {
  const [deleteWorkload] = useDeleteClusterLinkingWorkloadMutation();
  const { orgId, spId } = useParams();
  const { push } = useHistory();
  const header = `Delete Cluster Linking Workload ${clusterLinkingWorkloadName}`;
  const headerBody = <p>Are you sure you want to delete this Cluster Linking Workload?</p>;

  const onClickHandlerForOK = async () => {
    const { error } = await deleteWorkload({
      orgId,
      spId,
      clusterLinkingWorkloadId,
      payload: {
        cluster_linking_resource_id: clusterLinkingWorkloadResourceId,
        sp_version: spVersion,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Cluster Linking Workload delete was successful!');
      push(getLinkForStreamingProjectsSPPage(orgId, spId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
